import React, { useState, useEffect } from 'react';

function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const WHATSAPP_NUMBER = '628119634567'; // replace with your number, country code first, no + or leading 0
  const WHATSAPP_MESSAGE = 'Hi, I would like to know more about your services.';
  const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 border-b ${
      scrolled || mobileOpen
        ? 'bg-white/90 backdrop-blur-md border-gray-200' 
        : 'bg-transparent border-white/40'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          
          {/* Logo */}
          <a href="/testingpage">
            <img src="/logo_redoura.png" alt="Redoura" className="h-8 w-auto" />
          </a>

          {/* Desktop links */}
          <div className="hidden md:flex items-center space-x-4">
            <a href="/about" className={`text-sm transition ${scrolled ? 'text-gray-800 hover:text-gray-950' : 'text-white hover:text-white/70'}`}>About Us</a>
            <a href="/services" className={`text-sm transition ${scrolled ? 'text-gray-800 hover:text-gray-950' : 'text-white hover:text-white/70'}`}>Services</a>
            <a href="/ourclients" className={`text-sm transition ${scrolled ? 'text-gray-800 hover:text-gray-950' : 'text-white hover:text-white/70'}`}>Our Clients</a>
            <a href="/contactus" className={`text-sm transition ${scrolled ? 'text-gray-800 hover:text-gray-950' : 'text-white hover:text-white/70'}`}>Contact Us</a>

            
              <a href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-500 text-white text-sm px-4 py-2 rounded-lg transition"
            >
              Talk to Our Advisor
            </a>
          </div>

          {/* Mobile button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden ${scrolled ? 'text-gray-800' : 'text-white'}`}
          >
            {mobileOpen ? (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>

        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 px-4 py-4 space-y-3">
          <a href="/about" className="block text-gray-800 hover:text-gray-950 text-sm">About Us</a>
          <a href="/services" className="block text-gray-800 hover:text-gray-950 text-sm">Services</a>
          <a href="/ourclients" className="block text-gray-800 hover:text-gray-950 text-sm">Our Clients</a>
          <a href="/contactus" className="block text-gray-800 hover:text-gray-950 text-sm">Contact Us</a>

          
            <a href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-green-600 hover:bg-green-500 text-white text-sm px-4 py-2 rounded-lg text-center"
          >
            Talk to Our Advisor
          </a>
        </div>
      )}
    </nav>
  );
}

export default Navbar;